import React from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';

import { getCurrentUser } from 'redux/selectors/users';
import { getCurrentCourseActiveAICreationCommand } from 'redux/selectors/course';

import AiGeneratingLoader from 'lecture_pages/components/left-panel/novo-ai/components/shared/ai-generating-loader';

const AiGenerationLoader = () => {
  const currentUser = useSelector(getCurrentUser);
  const { isGenerating } = useSelector((state) => state.app.aiCourseCreation);
  const currentAICreationCommand = useSelector(getCurrentCourseActiveAICreationCommand);
  const aiCreationRequester = currentAICreationCommand?.requester;

  const isAiCreationInProgress = !!currentAICreationCommand && (currentAICreationCommand?.inProgress || isGenerating);
  const isCurrentUserGenerating = isAiCreationInProgress && currentUser.id === aiCreationRequester?.id;
  const isAnotherUserGenerating = isAiCreationInProgress && currentUser.id !== aiCreationRequester?.id;

  const styles = css`
    .aniText {
      height: 25px;
      font-size: 18px;
    }
  `;

  return (
    <div css={styles}>
      {isCurrentUserGenerating && (
        <div>
          <AiGeneratingLoader showLoaderDescription={false} />
        </div>
      )}
      {isAnotherUserGenerating && (
        <div className='mb-6'>
          <AiGeneratingLoader
            customDescription={
              t.LECTURE_PAGES.LHS.NOVO_AI.GENERATING_CONTENT(
                aiCreationRequester?.firstName,
                aiCreationRequester?.lastName,
              )
            }
          />
        </div>
      )}
    </div>
  );
};
export default AiGenerationLoader;
